import { Create, RichTextField, Edit, Show, Datagrid, DateField, FunctionField, EditButton, Filter, List, ShowButton, TextField, ReferenceField, SimpleForm, TextInput, DateInput, required, SelectInput, ArrayField, FileField, ArrayInput, SimpleFormIterator, FileInput } from "react-admin";
import React from "react";
import { RichTextInput } from 'ra-input-rich-text';
import LightBoxField from "../uiComponents/lightBoxField";
import ListPagination from "../uiComponents/ListPagination";
import { RecordAutocompleteInput } from "../helpers/commonForms";
const PostFilter = (props) => (
    <Filter {...props}>
        {/*<TextInput label="Search by Registration ID" source="registrationId" alwaysOn />*/}

        <RecordAutocompleteInput label="Search Record" source="recordId" alwaysOn emptyText="All Records" />

        <SelectInput alwaysOn emptyText="All Types"   source="type" label='Post Type'  choices={[
            {id: "Feedback", name: 'Feedback'},
            {id: "News", name: 'News'},
            {id: "Event", name: 'Event'},
            {id: "Certificate", name: 'Certificate'},
            {id: "Achievement", name: 'Achievement'},
            {id: "Other", name: 'Other'},


        ]}/>
    </Filter>
)

const list= props => {

        return <List perPage={50}  filters={<PostFilter/>}   {...props}    pagination={<ListPagination />} sort={{ field: 'date', order: 'DESC' }}>
            <Datagrid>
                <ReferenceField label="Finado Child" source="recordId" reference="Record">
                    <FunctionField label="Name" render={record => record ? record.registrationId+"-"+record.name+" "+record.fatherName : null} />
                </ReferenceField>
                <TextField source="type"  />
                <TextField source="title" sortable={true} />
                <DateField source="date" />
                <LightBoxField source={"files"} label={"File"}/>
                <ShowButton/>
                <EditButton/>

            </Datagrid>
        </List>
    }
;

const create = (props) => <Create {...props} >
    <SimpleForm redirect='list' initialValues={{date: new Date().toString()}}>
        <RecordAutocompleteInput label="Finado Child" source="recordId" />
        <DateInput source="date" />
        <SelectInput defaultValue={"Other"}   source="type"  choices={[
            {id: "Feedback", name: 'Feedback'},
            {id: "News", name: 'News'},
            {id: "Event", name: 'Event'},
            {id: "Certificate", name: 'Certificate'},
            {id: "Achievement", name: 'Achievement'},
            {id: "Other", name: 'Other'},


        ]}/>
        <TextInput source="title" validate={[required()]} fullWidth />
        <RichTextInput source="body" />
        <ArrayInput label='Attachments'  source="files">
            <SimpleFormIterator  >
                {/*<TextInput source="filePath" />*/}
                <FileInput source="filePath" label="File"  placeholder={<p>Drop your file here</p>}>
                    <FileField source="src" title="title" />
                </FileInput>

                <TextInput label='Title' source="title"   />




            </SimpleFormIterator>
        </ArrayInput>

    </SimpleForm>
</Create>

const edit = (props) => <Edit {...props}>
    <SimpleForm redirect='list'>
        <RecordAutocompleteInput label="Finado Child" source="recordId" />
        <DateInput source="date" defaultValue={new Date()} />
        <SelectInput defaultValue={"Other"}   source="type"  choices={[
            {id: "Achievement", name: 'Achievement'},
            {id: "Other", name: 'Other'},


        ]}/>
        <TextInput source="title" validate={[required()]} fullWidth />
        <RichTextInput source="body" />
        <ArrayInput label='Attachments'  source="files">
            <SimpleFormIterator  >
                {/*<TextInput source="filePath" />*/}
                <FileInput source="filePath" label="File"  placeholder={<p>Drop your file here</p>}>
                    <FileField source="src" title="title" />
                </FileInput>

                <TextInput label='Title' source="title"   />




            </SimpleFormIterator>
        </ArrayInput>

    </SimpleForm>
</Edit>

const show = (props) => <Show {...props} queryOptions={{ refetchOnMount: true }}>
  <SimpleForm>
      <DateField source="date"/>
      <ReferenceField  source="recordId" reference="Record">
          <TextField source="fullName" />
      </ReferenceField>
      <TextField source="title"/>
      <RichTextField source="body"/>
      <ArrayField label='Attachments'  source="files">



          <Datagrid bulkActionButtons={false} rowClick={false} empty={<span style={{ padding: '16px' }}>No attachments</span>}>


              <TextField label='Title' source="title"   />
              <FileField source="filePath" title="Open" target="_blank" rel="noopener noreferrer"  label="File"/>
              <LightBoxField label="Photo" source="filePath"/>

          </Datagrid>







      </ArrayField>
  </SimpleForm>
</Show>

const Posts = {list,create,edit,show}

export default Posts;
